import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const MeterIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 14.383 14.383">
      <g id="Group_301" data-name="Group 301">
        <g id="Group_300" data-name="Group 300" transform="translate(0 0)">
          <path
            id="Path_144"
            data-name="Path 144"
            d="M67.228,60A7.22,7.22,0,0,0,60,67.155a7.3,7.3,0,0,0,2.1,5.133.551.551,0,0,0,.778,0l.78-.78a.55.55,0,0,0-.778-.778L62.5,71.1a6.206,6.206,0,0,1-1.378-3.4h.526a.55.55,0,0,0,0-1.1h-.525a5.99,5.99,0,0,1,1.387-3.312l.362.362a.55.55,0,0,0,.778-.778l-.359-.359a6.139,6.139,0,0,1,3.383-1.391v.526a.55.55,0,0,0,1.1,0v-.525a6.025,6.025,0,0,1,3.238,1.31l-4.744,3.372a1.7,1.7,0,0,0-.769,1.346q0,.056,0,.112a1.72,1.72,0,0,0,1.72,1.539,1.655,1.655,0,0,0,1.346-.7l3.372-4.744a6.025,6.025,0,0,1,1.31,3.238h-.525a.55.55,0,1,0,0,1.1h.526a6.2,6.2,0,0,1-1.38,3.394l-.37-.37a.55.55,0,0,0-.778.778l.778.778a.551.551,0,0,0,.778,0,7.293,7.293,0,0,0,2.1-5.131A7.161,7.161,0,0,0,67.228,60Zm.449,7.473a.552.552,0,0,1-.449.232.622.622,0,0,1-.624-.55.65.65,0,0,1,.306-.449l2.653-1.886Z"
            transform="translate(-60 -60)"
            fill={props.color || theme.palette.primary.main}
          />
        </g>
      </g>
      <g id="Group_303" data-name="Group 303" transform="translate(4.403 11.081)">
        <g id="Group_302" data-name="Group 302" transform="translate(0 0)">
          <path
            id="Path_145"
            data-name="Path 145"
            d="M183.926,362h-2.275a1.651,1.651,0,0,0,0,3.3h2.275a1.651,1.651,0,0,0,0-3.3Zm0,2.2h-2.275a.55.55,0,1,1,0-1.1h2.275a.55.55,0,1,1,0,1.1Z"
            transform="translate(-180 -362)"
            fill={props.color || theme.palette.primary.main}
          />
        </g>
      </g>
    </SvgIcon>
  );
};
